import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: null,
  organizationId: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setOrganizationId: (state, action) => {
      state.organizationId = action.payload;
    },
    clearUserData: (state) => {
      state.userData = null;
      state.organizationId = null;
    },
  },
});

export const { setUserData, setOrganizationId, clearUserData } = userSlice.actions;
export default userSlice.reducer; 